import type { ComponentProps } from 'react';
import { StyleSheet } from 'react-native-unistyles';
import Text from '@/components/UI/Text';
import useRootStore from '@/stores/useRootStore';
import Avatar from '../../Custom/Avatar';
import Box from '../../UI/Box';
import Pressable, { style as containerStyle } from '../../Unistyles/Pressable';

export default function DrawerEntityListTeamItem({
  id,
  title,
  onPress,
  homePrimaryColor,
  avatarId,
}: {
  id: string;
  title: string;
  onPress?: ComponentProps<typeof Pressable>['onPress'];
  homePrimaryColor: string | null;
  avatarId: string | null;
}) {
  const isSelected = useRootStore(
    (state) =>
      state.teamId === id &&
      state.activeContextPathname === '/team' &&
      state.activeTab === 'team',
  );

  return (
    <Pressable
      accessibilityLabel={title}
      testID="DrawerTeamItem"
      styleOverride={({ pressed }) => [
        containerStyle.container(undefined),
        style.item(isSelected),
        pressed && containerStyle.active,
      ]}
      onPress={(event) => {
        onPress?.(event);
      }}
    >
      <Avatar
        color={homePrimaryColor}
        id={avatarId || ''}
        name={title || ''}
        size="sm"
      />
      <Box flex>
        <Text
          style={style.itemTitle(isSelected)}
          flexShrink={1}
          numberOfLines={3}
          size="md"
        >
          {title}
        </Text>
      </Box>
    </Pressable>
  );
}

const style = StyleSheet.create((theme) => ({
  item: (isSelected: boolean) => ({
    borderRadius: theme.borderRadius.xl,
    padding: theme.space('md'),
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.space('md'),
    backgroundColor: isSelected ? theme.colors.surfaceSecondary : 'transparent',
  }),
  itemTitle: (isSelected: boolean) => ({
    color: isSelected
      ? theme.colors.typography
      : theme.colors.typographySecondary,
  }),
}));
